import clsx from 'clsx'
import { ReactNode } from 'react'

import IconEmail from '@/assets/svg/purge/icons/icon-mail.svg'
import IconPhone from '@/assets/svg/purge/icons/icon-phone.svg'

import { ContactData } from './types'

const icons: Record<ContactData['key'], ReactNode> = {
  email: <IconEmail />,
  phone: <IconPhone />,
  fullName: <></>,
}

function ContactCard({
  data = {},
  title,
  children,
  className,
}: ContactCardProps) {
  const records = Object.entries(data).map(
    ([key, value]) => ({ key, value } as ContactData)
  )

  return (
    <div
      className={clsx(
        className,
        'border p-14 flex-1 border-gray-10 max-w-md text-white rounded-2xl'
      )}
    >
      <h3 className="mb-4 text-xl font-semibold">{title}</h3>
      <ul>
        {records.map(({ key, value }) => (
          <li key={key} className="flex">
            {icons[key] && (
              <div className="inline-block w-6 h-6 mr-2">{icons[key]}</div>
            )}
            {['email', 'phone'].includes(key) && (
              <a
                href={`${key === 'email' ? 'mailto' : 'tel'}:${value}`}
                className="inline text-white"
              >
                {value}
              </a>
            )}
            {key === 'fullName' && <p className="inline text-white">{value}</p>}
          </li>
        ))}
      </ul>
      {children}
    </div>
  )
}

interface ContactCardProps {
  title: string
  data?: {
    fullName?: string
    email?: string
    phone?: number
  }
  children?: JSX.Element | JSX.Element[]
  className?: string
}

export default ContactCard
